/**
 * Console.log the data section for dev debugger.
 */
export var Log = function Log() {
  return function (data) {
    console.log('G2 data section:', data);
    return data;
  };
};
Log.props = {};